import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getCouponList = createAsyncThunk(
    "getCouponList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/package/fetch-all-coupons?page=${body.page}&search=${body.search}&status=${body.status}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const CouponSlice = createSlice({
    name: "CouponSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCouponList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getCouponList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getCouponList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default CouponSlice.reducer;
